import styled from 'styled-components'

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-family: 'Inter', sans-serif;
  overflow: hidden;
  min-height: 0;
  margin-top: 15px;
`

export const LoadingMessage = styled.p`
  display: flex;
  justify-content: center;
  text-align: center;
  background-color: #f5f5f5;

  img {
    width: 50px;
    margin-top: 30vh;
  }
`
